function excludeAccountQuestionIfLoggedIn(user, userProfile, answers) {
  let filteredAnswers = answers.slice(0);

  if (user && userProfile) {
    filteredAnswers = filteredAnswers.filter((answer) => {
      return answer.q_title !== "Account";
    });

    if (userProfile.FirstName) {
      filteredAnswers = filteredAnswers.filter((answer) => {
        return answer.q_title !== "First name";
      });
    }

    if (userProfile.LastName) {
      filteredAnswers = filteredAnswers.filter((answer) => {
        return answer.q_title !== "Last name";
      });
    }

    if (userProfile.Email) {
      filteredAnswers = filteredAnswers.filter((answer) => {
        return answer.q_title !== "Email";
      });
    }

    if (userProfile.PhoneNumber) {
      filteredAnswers = filteredAnswers.filter((answer) => {
        return answer.q_title !== "Phone";
      });
    }

    return filteredAnswers;
  } else {
    return filteredAnswers;
  }
}

export default excludeAccountQuestionIfLoggedIn;
